import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faBuildingUser, faUserTie, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import StatCard from './StatCard';
import { useAuth } from '../../utils/AuthContext';
import { format } from 'date-fns';
import ViewUser from './ViewUsers';
import LiveVideo from './LiveVideo';
const AdminDashboard = () => {
  const [counts, setCounts] = useState(null);
  const { userData } = useAuth();
  const monthday = format(new Date(), 'dd, MMMM');

 
  useEffect(() => {
    const fetchData = async () => {
    
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/Counts`);
        setCounts(response.data);
      } catch (error) {
        console.error('Error fetching dashboard data', error);
      }
    };

    fetchData();
  }, []);

  if (!counts) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-100">
      <div className="relative bg-indigo-300 p-6 rounded-2xl overflow-hidden mb-6">
        <div
          className="absolute right-0 top-0 -mt-4 mr-16 pointer-events-none hidden md:block"
          aria-hidden="true"
        >
          <svg
            width="319"
            height="198"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path id="welcome-a" d="M64 0l64 128-64-20-64 20z" />
              <path id="welcome-e" d="M40 0l40 80-40-12.5L0 80z" />
              <path id="welcome-g" d="M40 0l40 80-40-12.5L0 80z" />
              <linearGradient
                x1="50%"
                y1="0%"
                x2="50%"
                y2="100%"
                id="welcome-b"
              >
                <stop stopColor="#A5B4FC" offset="0%" />
                <stop stopColor="#818CF8" offset="100%" />
              </linearGradient>
              <linearGradient
                x1="50%"
                y1="24.537%"
                x2="50%"
                y2="100%"
                id="welcome-c"
              >
                <stop stopColor="#4338CA" offset="0%" />
                <stop stopColor="#6366F1" stopOpacity="0" offset="100%" />
              </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="rotate(64 36.592 105.604)">
                <mask id="welcome-d" fill="#fff">
                  <use xlinkHref="#welcome-a" />
                </mask>
                <use fill="url(#welcome-b)" xlinkHref="#welcome-a" />
                <path
                  fill="url(#welcome-c)"
                  mask="url(#welcome-d)"
                  d="M64-24h80v152H64z"
                />
              </g>
              <g transform="rotate(-51 91.324 -105.372)">
                <mask id="welcome-f" fill="#fff">
                  <use xlinkHref="#welcome-e" />
                </mask>
                <use fill="url(#welcome-b)" xlinkHref="#welcome-e" />
                <path
                  fill="url(#welcome-c)"
                  mask="url(#welcome-f)"
                  d="M40.333-15.147h50v95h-50z"
                />
              </g>
              <g transform="rotate(44 61.546 392.623)">
                <mask id="welcome-h" fill="#fff">
                  <use xlinkHref="#welcome-g" />
                </mask>
                <use fill="url(#welcome-b)" xlinkHref="#welcome-g" />
                <path
                  fill="url(#welcome-c)"
                  mask="url(#welcome-h)"
                  d="M40.333-15.147h50v95h-50z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mb-6 gap-6">
        <StatCard
          StatName="Total Users"
          StatNumber={counts.totalUserCount}
          Description={"-"}
          IconBg={"green.100"}
          StatIcon={<FontAwesomeIcon className="text-green-600 text-xl" icon={faUsers} />}
        />

        <StatCard
          StatName="Active Users"
          StatNumber={counts.activeUserCount}
          Description={"-"}
          IconBg={"blue.100"}
          StatIcon={<FontAwesomeIcon className="text-blue-600 text-2xl" icon={faBuildingUser} />}
        />

        <StatCard
          StatName="Participants"
          StatNumber={counts.eligibleUserCount}
          Description={monthday}
          IconBg={"purple.100"}
          StatIcon={<FontAwesomeIcon className="text-purple-600 text-2xl" icon={faUserTie} />}
        />

        <StatCard
          StatName="Alerts"
          StatNumber={counts.alertsCount}
          Description={"Pending Exam"}
          IconBg={"red.100"}
          StatIcon={<FontAwesomeIcon className="text-red-600 text-xl" icon={faTriangleExclamation} />}
        />
      </div>

      <div className="bg-white rounded-2xl drop-shadow-md p-4 mt-4">
        <div className="border-b border-slate-400 pb-2 mb-4">
          <h1 className="text-lg font-semibold text-gray-800">
            User Information
          </h1>
        </div>
        
        <ViewUser userData={userData} />
      </div>
    </div>
  );
};

export default AdminDashboard;
